import Transform from 'ember-data/transform';
import { isNone } from '@ember/utils';
import { queryEncode, queryDecode } from 'cio/helpers/query';

// multiConditions are an array of conditions associated with multi-split
// actions.
//
// Each multi-split action has the exact same conditions in the array with
// different "values".  When a condition with an empty value is saved, we want
// to transform it to an empty condition instead. That is an empty array.

type ConditionList = Record<string, any>[];
type MultiConditions = ConditionList[];

export default Transform.extend({
  deserialize(serialized: string[]): MultiConditions | null {
    try {
      return serialized.map(queryDecode) as MultiConditions;
    } catch (e) {
      return null;
    }
  },

  serialize(deserialized: MultiConditions | null): string[] | null {
    return isNone(deserialized)
      ? deserialized
      : deserialized.map((item) => {
          // If this is an attribute or event_attribute condition and the
          // condition has no value, filter it out so that we can encode an empty
          // array.
          return queryEncode(item);
        });
  },
});

declare module 'ember-data/types/registries/transform' {
  export default interface TransformRegistry {
    'multi-conditions': MultiConditions;
  }
}
